// Calculator Utility Functions

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Format currency based on locale
 */
export const formatCurrency = (amount, currency, locale) => {
  if (locale === 'de-CH') {
    const formatted = amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return `${currency} ${formatted}`;
  } else {
    const formatted = amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${formatted} ${currency}`;
  }
};

/**
 * Convert amount to display currency based on calculation result
 */
export const convertToDisplayCurrency = (amountEur, calculationResult) => {
  if (!calculationResult) return Math.round(amountEur);
  
  const exchangeRate = calculationResult.chf_to_eur_rate || 0.95;
  
  if (calculationResult.values_in_target_currency) {
    if (calculationResult.currency === 'EUR') {
      return Math.round(amountEur * exchangeRate);
    }
    return Math.round(amountEur);
  }
  
  if (calculationResult.currency === 'CHF') {
    return Math.round(amountEur / exchangeRate);
  }
  return Math.round(amountEur);
};

/**
 * Get energy unit based on heating system
 */
export const getEnergyUnit = (system) => {
  switch (system) {
    case 'oel': return 'Liter/Jahr';
    case 'gas': return 'm³/Jahr';
    case 'elektro': return 'kWh Strom/Jahr';
    case 'holz': return 'm³ Raummeter/Jahr';
    case 'luft_wp': return 'kWh erzeugte Wärmeenergie/Jahr';
    default: return 'Einheit/Jahr';
  }
};

/**
 * Get energy placeholder based on heating system
 */
export const getEnergyPlaceholder = (system) => {
  switch (system) {
    case 'oel': return 'z.B. 2500';
    case 'gas': return 'z.B. 2000';
    case 'elektro': return 'z.B. 15000';
    case 'holz': return 'z.B. 10';
    case 'luft_wp': return 'z.B. 15000';
    default: return 'z.B. 2000';
  }
};

/**
 * Step labels for progress bar
 */
export const STEP_LABELS = {
  1: 'PLZ',
  2: 'Projekt',
  3: 'Bedarf',
  4: 'Details',
  5: 'Ergebnis',
  6: 'Kontakt'
};

/**
 * Initial form data
 */
export const INITIAL_FORM_DATA = {
  plz: '',
  country: '',
  location_name: '',
  project_type: 'neubau',
  building_type: 'efh',
  building_type_other: '',
  area_m2: '',
  heating_hot_water: true,
  persons: '',
  altitude_m: '',
  prev_system: '',
  prev_consumption_kwh: '',
  energy_consumption_kwh: '',
  energy_includes_hot_water: null,
  timeframe: 'sofort',
  free_cooling: false,
  has_subsidy: false,
  subsidy_amount_erdwaerme: '',
  subsidy_amount_luftwaerme: '',
  has_installer: null,
  installer_info: '',
  name: '',
  email: '',
  phone: '',
  address: '',
  additional_info: '',
  consent: false
};

/**
 * Initial waitlist data
 */
export const INITIAL_WAITLIST_DATA = {
  name: '',
  email: '',
  consent: false
};
